import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule, Pipe } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { CountToModule } from '../app/controls/count-to.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateAdapter, NgbDateStruct, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import 'hammerjs';
import 'mousetrap';
import { ModalGalleryModule } from '@ks89/angular-modal-gallery';
import { CalendarModule as PrimePicker } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

import { AppComponent } from './app.component';
import { NetHoldingsComponent } from './pages/home/net-holdings/net-holdings.component';
import { AuthService } from '../app/services/auth.service';
import { LoginComponent } from './pages/login/login.component';
import { JobComponent } from './pages/reports/rs/job/job.component';

/*import { LoadingComponent } from './components/loading/loading.component';*/

import { RoleGuard } from '../app/services/role.guard';
import { UserGuard } from '../app/services/user.guard';
import { CookieService } from 'ngx-cookie-service';
import { AssetRegisterService } from './services/rs/assetregister.service';
import { CategoryService } from './services/category.service';
import { ManufacturerService } from './services/manufacturer.service';
import { OwnerService } from './services/owner.service';
import { ReportableService } from './services/reportable.service';
import { CompanyService } from './services/company.service';
import { LocationService } from './services/location.service';
import { EquipmentService } from './services/equipment.service';
import { JobService } from './services/RS/job.service';
import { InspectionService } from './services/rs/inspection.service';
import { BreakdownService } from './services/rs/breakdown.service';
import { ServiceInspectionService } from './services/rs/service-inspection.service';
import { BreakdownInspectionService } from './services/rs/breakdown-inspection.service';
import { PartService } from './services/parts.service';
import { ColourService } from './services/rs/colour.service';
import { RAMSService } from './services/rs/rams.service';
import { ERSTRService } from './services/rs/erstr.service';
import { MassUploadService } from './services/rs/massupload.service';
import { RemindersService } from './services/rs/reminders.service';
import { BasketService } from './services/rs/basket.service';
import { CustomerTypeService } from './services/customer-type.service'

import { LayoutComponent } from '../app/layout/layout.component';
import { UserComponent } from './layout/user/user.component';

import { CategoriesComponent } from './pages/administration/categories/categories.component';
import { CategoryManageComponent } from './pages/administration/categories/category-manage/category-manage.component';
import { ManufacturersComponent } from './pages/administration/manufacturers/manufacturers.component';
import { ManufacturerManageComponent } from './pages/administration/manufacturers/manufacturer-manage/manufacturer-manage.component';
import { CompaniesComponent } from './pages/administration/companies/companies.component';
import { CompanyManageComponent } from './pages/administration/companies/company-manage/company-manage.component';
import { LocationsComponent } from './pages/administration/locations/locations.component';
import { LocationManageComponent } from './pages/administration/locations/location-manage/location-manage.component';
import { EquipmentComponent } from './pages/administration/equipment/equipment.component';
import { EquipmentManageComponent } from './pages/administration/equipment/equipment-manage/equipment-manage.component';
import { JobManagementComponent } from './pages/administration/job-management/job-management.component';
import { JobManageComponent } from './pages/administration/job-management/job-manage/job-manage.component';
import { InspectionsComponent } from './pages/reports/rs/inspections/inspections.component';
import { ServiceInspectionsComponent } from './pages/reports/rs/service-inspections/service-inspections.component';
import { BreakdownInspectionsComponent } from './pages/reports/breakdown-inspections/breakdown-inspections.component';
import { RamsComponent } from './pages/reports/rs/rams/rams.component';
import { JobApprovalComponent } from './pages/administration/job-approval/job-approval.component';
import { JobDetailsComponent } from './pages/administration/job-approval/job-details/job-details.component';
import { ErstrComponent } from './pages/reports/rs/erstr/erstr.component';
import { AssetRegisterComponent } from './pages/reports/assetregister/assetregister.component';
import { DeliveryNotesComponent } from './pages/home/delivery-notes/delivery-notes.component';
import { MassUploadComponent } from './pages/administration/massupload/massupload.component';
import { CreateComponent as ErstrCreateComponent } from './pages/reports/rs/erstr/create/create.component';
import { JobAmendComponent as JobAmendComponent } from './pages/administration/job-approval/job-amend/job-amend.component';
import { JobResolver } from './resolvers/job-resolver';
import { TimesheetComponent } from './pages/reports/rs/timesheet/timesheet.component';
import { TimesheetAmendComponent } from './pages/reports/rs/timesheet/amend/timesheet-amend.component';
import { ReminderComponent } from './pages/reports/rs/reminder/reminder.component';
import { FilterService } from './services/filter.service';
import { BasketComponent } from './pages/basket/basket.component';
import { BreakdownInspectionsReportComponent } from './pages/reports/breakdown-inspections-report/breakdown-inspections-report.component';
import { ApiHttpInterceptor } from './services/api-http-interceptor';
import { NetHoldingsService } from './services/net-holdings.service';
import { RegionService } from './services/region.service';
import { ProductTypeService } from './services/product-type.service';
import { DeliveryNotesService } from './services/delivery-notes.service';
import { DistributionReportComponent } from './pages/reports/distribution-report/distribution-report.component';
import { DistributionReportService } from './services/distribution-report.service';
import { AuditOpeningStockCylsService } from './services/audit-opening-stock-cyls.service';
import { AuditOpeningStockCylsComponent } from './pages/reports/distribution-report/audit-opening-stock-cyls/audit-opening-stock-cyls.component';
import { CollectionsDeliveriesComponent } from './pages/reports/distribution-report/collections-deliveries/collections-deliveries.component';
import { CollectionsDeliveriesService } from './services/collections-deliveries.service';
import { CylHistoryService } from './services/cyl-history.service';
import { CylHistoryComponent } from './pages/reports/distribution-report/cyl-history/cyl-history.component';
import { CylinderHistoryComponent } from './pages/reports/cylinder_status_report/cylinder_history/cylinder_history.component';
import { PopUpModalComponent } from '../app/components/modals/popup-modal/popup-modal.component';
import { FullModalComponent } from '../app/components/modals/fullscreen-modal/fullscreen-modal.component';
import { EditLocationComponent } from './pages/reports/distribution-report/Edit-Location/edit-location.component';
import { AuditReportService } from './services/audit-report.service';
import { AuditReportComponent } from './pages/reports/audit-report/audit-report.component';
import { ExpiredGasReportService } from './services/expired-gas-report.service';
import { ExpiredGasReportComponent } from './pages/reports/expired-gas-report/expired-gas-report.component';
import { StockLevelReportComponent } from './pages/reports/stock-level-report/stock-level-report.component';
import { StockLevelReportService } from './services/stock-level-report.service';
import { StockLevelLocationService } from './services/stock-level-location.service';
import { StockLevelLocationComponent } from './pages/reports/stock-level-report/stock-level-location/stock-level-location.component';
import { ClientAuditReportComponent } from './pages/reports/client-audit-report/client-audit-report.component';
import { ClientAuditReportService } from './services/client-audit-report.service';
import { VehicleService } from './services/vehicle.service';
import { ClientAuditCylsService } from './services/client-audit-cyls.service';
import { ClientAuditCylsComponent } from './pages/reports/client-audit-report/client-audit-cyls/client-audit-cyls.component';
import { ServiceReportService } from './services/service-report.service';
import { ServiceReportComponent } from './pages/reports/service-report/service-report.component';
import { ActivityReportService } from './services/activity-report.service';
import { ActivityReportComponent } from './pages/reports/activity-report/activity-report.component';
import { DeliverCollectReportComponent } from './pages/reports/deliver-collect-report/deliver-collect-report.component';
import { DeliverCollectReportService } from './services/deliver-collect-report.service';
import { LastSeenReportService } from './services/last-seen-report.service';
import { LastSeenReportComponent } from './pages/reports/last-seen-report/last-seen-report.component';
import { ExpiredReportService } from './services/expired-report.service';
import { ExpiredReportComponent } from './pages/reports/expired-report/expired-report.component';
import { FillBatchCylComponent } from './pages/reports/Popups/fill-batch-cyl/fill-batch-cyl.component';
import { FillBatchReportService } from './services/fill-batch-report.service';
import { EditFillBatchComponent } from './pages/reports/Popups/edit-fill-batch/edit-fill-batch.component';
import { FillBatchReportComponent } from './pages/reports/fill-batch-report/fill-batch-report.component';
import { ExportCollectionReportComponent } from './pages/reports/export-collection/export-collection-report.component';
import { ExportCollectionReportService } from './services/export-collection-report.service';
import { CylinderStatusReportComponent } from './pages/reports/cylinder_status_report/cylinder_status_report.component';
import { CylinderStatusReportService } from './services/cylinder_status_report.service';
import { QuarantinedReportComponent } from './pages/reports/quarantined-report/quarantined-report.component';
import { QuarantinedReportService } from './services/quarantined-report.service';
import { AuditLogHistoryComponent } from './pages/reports/Popups/audit-log-history/audit-log-history.component';
import { AuditLogHistoryService } from './services/audit-log-history.service';
import { WebUserManageComponent } from './pages/administration/web-users/web-user-manage/web-user-manage.component';
import { WebUsersComponent } from './pages/administration/web-users/web-users.component';
import { WebUserService } from './services/web-user.service'
import { PDAUserService } from './services/pda-user.service'
import { PDAUserManageComponent } from './pages/administration/pda-users/pda-user-manage/pda-user-manage.component';
import { PDAUserComponent } from './pages/administration/pda-users/pda-users.component';
import { UploadCylindersComponent } from './pages/administration/upload-management/upload-cylinders/upload-cylinders.component';
import { UploadDeliveriesCollections } from './pages/administration/upload-management/upload-deliveries-collections/upload-deliveries-collections.component';
import { UploadFillBatchComponent } from './pages/administration/upload-management/upload-fill-batch/upload-fill-batch.component';
import { UploadService } from './services/upload.service';
import { MergeService } from './services/merge.service';
import { MergeManagementComponent } from './pages/administration/merge-management/merge-management.component';
import { AuditChartComponent } from './pages/reports/distribution-report/audit-chart/audit-chart.component';
import { MultiSelectComponent } from '../app/components/modals/multi-select-modal/multi-select-modal.component';
import { ColumnService } from './services/ColumnService';
import { BooleanNullDisplayPipe } from './components/pipes/boolean-null-display.pipe';
import { ManagedCylinderInformationComponent } from './pages/administration/managed-cylinder-information/managed-cylinder-information.component';
import { ManagedCylinderInformationManageComponent } from './pages/administration/managed-cylinder-information/managed-cylinder-information-manage/managed-cylinder-information-manage.component';
import { ManagedCylinderInformationService } from './services/managed-cylinder-information.service';
import { CylinderSizeService } from './services/cylinder-size.service';

@Pipe({ name: 'safeHtml' })

export class Safe {
  constructor(private sanitizer: DomSanitizer) { }

  transform(style) {
    console.log(style);
    return this.sanitizer.bypassSecurityTrustHtml(style);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    NetHoldingsComponent,
    LoginComponent,
    LayoutComponent,
    UserComponent,
    CategoriesComponent,
    CategoryManageComponent,
    ManufacturersComponent,
    ManufacturerManageComponent,
    Safe,
    CompaniesComponent,
    CompanyManageComponent,
    LocationsComponent,
    LocationManageComponent,
    EquipmentComponent,
    EquipmentManageComponent,
    JobManagementComponent,
    JobManageComponent,
    InspectionsComponent,
    ServiceInspectionsComponent,
    BreakdownInspectionsComponent,
    RamsComponent,
    JobApprovalComponent,
    JobDetailsComponent,
    TimesheetComponent,
    TimesheetAmendComponent,
    MassUploadComponent,
    ErstrComponent,
    JobAmendComponent,
    ErstrCreateComponent,
    ReminderComponent,
    AssetRegisterComponent,
    BasketComponent,
    BreakdownInspectionsReportComponent,
    JobComponent,
    DeliveryNotesComponent,
    DistributionReportComponent,
    AuditOpeningStockCylsComponent,
    CollectionsDeliveriesComponent,
    CylHistoryComponent,
    CylinderHistoryComponent,
    PopUpModalComponent,
    FullModalComponent,
    EditLocationComponent,
    AuditReportComponent,
    ExpiredGasReportComponent,
    StockLevelReportComponent,
    StockLevelLocationComponent,
    ClientAuditReportComponent,
    ClientAuditCylsComponent,
    ServiceReportComponent,
    ActivityReportComponent,
    DeliverCollectReportComponent,
    LastSeenReportComponent,
    ExpiredReportComponent,
    FillBatchCylComponent,
    EditFillBatchComponent,
    FillBatchReportComponent,
    ExportCollectionReportComponent,
    CylinderStatusReportComponent,
    QuarantinedReportComponent,
    AuditLogHistoryComponent,
    WebUserManageComponent,
    WebUsersComponent,
    PDAUserComponent,
    PDAUserManageComponent,
    UploadCylindersComponent,
    UploadDeliveriesCollections,
    UploadFillBatchComponent,
    MergeManagementComponent,
    AuditChartComponent,
    MultiSelectComponent,
    BooleanNullDisplayPipe,
    ManagedCylinderInformationComponent,
    ManagedCylinderInformationManageComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    NgxDatatableModule,
    NgxChartsModule,
    HttpClientModule,
    NgHttpLoaderModule,
    FormsModule,
    ReactiveFormsModule,
    CountToModule,
    SnotifyModule,
    ModalGalleryModule.forRoot(),
    PrimePicker,
    ConfirmDialogModule,
    NgbModule.forRoot(),
    RouterModule.forRoot([
      { path: '', redirectTo: '/home', pathMatch: 'full', canActivate: [RoleGuard] },
      { path: 'login', component: LoginComponent },
      {
        path: 'home', canActivate: [RoleGuard], children: [
          { path: 'net_holdings', component: NetHoldingsComponent },
          { path: 'delivery_notes', component: DeliveryNotesComponent },
        ]
      },
      {
        path: 'reports', canActivate: [RoleGuard], children: [
          { path: 'assetregister', component: AssetRegisterComponent },
          { path: 'inspections', component: InspectionsComponent },
          { path: 'distribution_report', component: DistributionReportComponent },
          { path: 'distribution_report/audit_opening_stock_cyls', component: AuditOpeningStockCylsComponent },
          { path: 'distribution_report/audit_chart', component: AuditChartComponent },
          { path: 'distribution_report/collections_and_deliveries', component: CollectionsDeliveriesComponent },
          { path: 'distribution_report/cyl_history', component: CylHistoryComponent },
          { path: 'cylinder_status_report/cylinder_history', component: CylinderHistoryComponent },
          { path: 'distribution_report/edit_location', component: EditLocationComponent },
          { path: 'audit_report', component: AuditReportComponent },
          { path: 'audit_report/cyls', component: ClientAuditCylsComponent }, 
          { path: 'expired_gas_report', component: ExpiredGasReportComponent },
          { path: 'stock_level_report', component: StockLevelReportComponent },
          { path: 'stock_level_report/location', component: StockLevelReportComponent },
          { path: 'client_audit_report', component: ClientAuditReportComponent },
          { path: 'client_audit_report/cyls', component: ClientAuditCylsComponent },
          { path: 'service_report', component: ServiceReportComponent },
          { path: 'no_activity_report', component: ActivityReportComponent },
          { path: 'deliver_collect_report', component: DeliverCollectReportComponent },
          { path: 'last_seen_report', component: LastSeenReportComponent },
          { path: 'expired_report', component: ExpiredReportComponent },
          { path: 'fill_batch_cyl', component: FillBatchCylComponent },
          { path: 'fill_batch_report', component: FillBatchReportComponent },
          { path: 'export_collection_report', component: ExportCollectionReportComponent },
          { path: 'cylinder_status_report', component: CylinderStatusReportComponent },
          { path: 'quarantined_report', component: QuarantinedReportComponent },
        ]
      },  
      {
        path: 'users', canActivate: [RoleGuard], children: [ //[RoleGuard, UserGuard]
          { path: 'web_management', component: WebUsersComponent },
          { path: 'web_management/manage', component: WebUserManageComponent },
          { path: 'tablet_management', component: PDAUserComponent },
          { path: 'tablet_management/manage', component: PDAUserManageComponent },
        ]
      },
      {
        path: 'upload', canActivate: [RoleGuard], children: [
          { path: 'cylinders', component: UploadCylindersComponent },
          { path: 'deliveries_collections', component: UploadDeliveriesCollections },
          { path: 'fill_batch', component: UploadFillBatchComponent },
        ]
      },
      {
        path: 'administration', canActivate: [RoleGuard], children: [
          { path: 'customer_management', component: CompaniesComponent },
          { path: 'customer_management/manage', component: CompanyManageComponent },
          { path: 'location_management', component: LocationsComponent },
          { path: 'location_management/manage', component: LocationManageComponent },
          { path: 'managed-cylinder-information-management', component: ManagedCylinderInformationComponent },
          { path: 'managed-cylinder-information-management/manage', component: ManagedCylinderInformationManageComponent },
          { path: 'merge_management', component: MergeManagementComponent }
        ]
      },
    ])
  ],
  providers: [
    CookieService,
    AuthService,
    RoleGuard,
    UserGuard,
    CategoryService,
    ManufacturerService,
    OwnerService,
    ReportableService,
    CompanyService,
    LocationService,
    EquipmentService,
    InspectionService,
    BreakdownService,
    ServiceInspectionService,
    BreakdownInspectionService,
    JobService,
    PartService,
    ColourService,
    RAMSService,
    ERSTRService,
    MassUploadService,
    FilterService,
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService,
    ConfirmationService,
    JobResolver,
    RemindersService,
    CookieService,
    BasketService,
    AssetRegisterService,
    NetHoldingsService,
    CustomerTypeService,
    RegionService,
    ProductTypeService,
    DeliveryNotesService,
    DistributionReportService,
    AuditOpeningStockCylsService,
    CollectionsDeliveriesService,
    CylHistoryService,
    AuditReportService,
    ExpiredGasReportService,
    StockLevelReportService,
    StockLevelLocationService,
    ClientAuditReportService,
    VehicleService,
    ClientAuditCylsService,
    ServiceReportService,
    ActivityReportService,
    DeliverCollectReportService,
    LastSeenReportService,
    ExpiredReportService,
    FillBatchReportService,
    ExportCollectionReportService,
    CylinderStatusReportService,
    QuarantinedReportService,
    AuditLogHistoryService,
    WebUserService,
    PDAUserService,
    UploadService,
    MergeService,
    { provide: HTTP_INTERCEPTORS, useClass: ApiHttpInterceptor, multi: true },
    ColumnService,
    ManagedCylinderInformationService,
    CylinderSizeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export class NgbdDatepickerAdapter {

  model1: Date;
  model2: Date;

  get today() {
    return new Date();
  }
}
